/* eslint-disable no-unused-vars */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Center, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import TicketSummary from '../../components/TicketSummary/TicketSummary';
import PrimaryButton from '../../components/GroupButton';
import TimerEvent from '../../components/TimerEvent/TimerEvent';

const AddVasTicket = () => {
  const { search } = useLocation();
  const { t, i18n } = useTranslation();
  const searchParams = new URLSearchParams(search);
  const passIdData = searchParams.get('passId');
  const name = searchParams.get('name');
  const mobile = searchParams.get('mobile');

  return (
    <Box>
      {passIdData ? <TimerEvent /> : null}
      <Center className="no-printme">
        <Title style={{ color: '#F9D923' }} order={1}>
          {t('enter.ticket.summary')}
        </Title>
      </Center>
      <Center className="no-printme" py="xl">
        <TicketSummary passId={passIdData} name={name} mobile={mobile} />
      </Center>
      <PrimaryButton />
    </Box>
  );
};

export default AddVasTicket;
